import BaseStore from './BaseStore';
import type { Modal } from '$shared/models/Modal';

type ModalStoreType = {
  list: Modal[];
};

const InitialState: ModalStoreType = {
  list: []
};

class ModalStore extends BaseStore<ModalStoreType> {
  constructor() {
    super(InitialState);
  }

  public get list(): Modal[] {
    return this.getValue('list') || [];
  }

  public create(modal: Modal): void {
    this.store.update((state) => {
      state.list = [...state.list, modal];
      return state;
    });
  }

  public updateList(modal: Modal): void {
    if (!modal) return;

    const modals = this.list;
    const currentModalIndex = modals?.findIndex((item) => item.id === modal.id);
    currentModalIndex > -1 && (modals[currentModalIndex] = modal);
    this.update('list', modals);
  }

  public setList(modals: Modal[]): void {
    this.update('list', modals);
  }
}

export const modalStore = new ModalStore();
